import {
  IonButton,
  IonButtons, IonChip, IonContent,
  IonHeader, IonIcon, IonInput, IonItem,
  IonLabel, IonList,
  IonMenuButton, IonModal,
  IonPage, IonTitle,
  IonToolbar
} from "@ionic/react";
import React, {useEffect, useRef, useState} from "react";
import {filter, menu, closeCircle} from 'ionicons/icons'
import {connect} from "react-redux";
import AprsLogbookContent from "./AprsLogbookContent";
import {REST_APRSLOGBOOK_URL} from "../common/constants";
import { suggestAprsLogbookIdentifiers, suggestAprsLogbookPlaces } from "../common/ApiUtils";
import Flatpickr from "react-flatpickr";
import {formatDate} from "../common/TimeUtils";


function getStorageValue(key, defaultValue) {
  // getting stored value
  const saved = localStorage.getItem(key);
  const initial = JSON.parse(saved);
  return initial || defaultValue;
}

export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};


const AprsLogbookCls = ({day}) => {

  const refContainer = useRef(0);
  const idSuggestTimer = useRef(null);
  const placeSuggestTimer = useRef(null);
  const [showFilter, setShowFilter] = useState(false);
  const [filterPlace, setFilterPlace] = useLocalStorage("aprsFilterPlace", "");
  const [filterIdentifier, setFilterIdentifier] = useLocalStorage("aprsFilterIdentifier", "");
  const [filterDay, setFilterDay] = useState(null);
  const [inputDay, setInputDay] = useState(null);
  const [identifierDraft, setIdentifierDraft] = useState("");
  const [placeDraft, setPlaceDraft] = useState("");
  const [idSuggestions, setIdSuggestions] = useState([]);
  const [placeSuggestions, setPlaceSuggestions] = useState([]);

  const openFilter = () => {
    setIdentifierDraft(filterIdentifier);
    setPlaceDraft(filterPlace);
    setInputDay(filterDay);
    setIdSuggestions([]);
    setPlaceSuggestions([]);
    setShowFilter(true);
  };

  const scheduleIdSuggest = (raw) => {
    if (idSuggestTimer.current) {
      clearTimeout(idSuggestTimer.current);
    }
    idSuggestTimer.current = setTimeout(async () => {
      const t = (raw ?? "").trim();
      if (t.length < 1) {
        setIdSuggestions([]);
        return;
      }
      try {
        const res = await suggestAprsLogbookIdentifiers(t, 25);
        setIdSuggestions(Array.isArray(res) ? res : []);
      } catch (e) {
        setIdSuggestions([]);
      }
    }, 250);
  };

  const schedulePlaceSuggest = (raw) => {
    if (placeSuggestTimer.current) {
      clearTimeout(placeSuggestTimer.current);
    }
    placeSuggestTimer.current = setTimeout(async () => {
      const t = (raw ?? "").trim();
      if (t.length < 1) {
        setPlaceSuggestions([]);
        return;
      }
      try {
        const res = await suggestAprsLogbookPlaces(t, 25);
        setPlaceSuggestions(Array.isArray(res) ? res : []);
      } catch (e) {
        setPlaceSuggestions([]);
      }
    }, 250);
  };



  /*const updateTracker = async () => {
    const res = await loadResource(concatUrlId(UPDATE_TRACKER_URL, day.replace(/\./g, "-")));
    if (!res.ok) {
      toastMessage = res.message;
      setShowToast(true);
    } else {
      refContainer.current.loadEntityResource();
    }
  };*/

/*  const setFilter = (value) => {
    setFilterValue(value);
  };
*/
 // const filterFce = (entity) => filterValue ? entity.registration === filterValue : entity;

  const getUrlApiQuery = () => {
    var url = REST_APRSLOGBOOK_URL;
    if (filterPlace) {
      url += "/search/findAllByTakeoffPlaceOrLandingPlace?takeOffPlace="+filterPlace+"&landingPlace=" +filterPlace;
    }
    return url;
  }

  const applyFilter = () => {
    setShowFilter(false);
    setFilterIdentifier((identifierDraft || "").trim());
    setFilterPlace((placeDraft || "").trim().toUpperCase());
    setFilterDay(inputDay);
    setIdSuggestions([]);
    setPlaceSuggestions([]);
  }

  const onDateChange = (date) => {
    if (date) {
      setInputDay(formatDate(date));
    }
  }


  return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
                <IonButton slot={'start'} color={'primary'} onClick={openFilter}>
                  <IonIcon icon={filter}/> Filtr
                </IonButton>
            </IonButtons>
            {filterIdentifier &&
            <IonChip onClick={() => setFilterIdentifier("")}>
              <IonLabel>{filterIdentifier}</IonLabel>
              <IonIcon icon={closeCircle} />
            </IonChip>
            }
            {filterPlace &&
              <IonChip onClick={() => setFilterPlace("")}>
                <IonLabel>{filterPlace}</IonLabel>
                <IonIcon icon={closeCircle} />
              </IonChip>
             }
            {filterDay &&
            <IonChip onClick={() => setFilterDay(null)}>
              <IonLabel>{filterDay}</IonLabel>
              <IonIcon icon={closeCircle} />
            </IonChip>
            }
            <IonButtons slot="end">
              <IonMenuButton><IonIcon icon={menu}/></IonMenuButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonModal isOpen={showFilter} cssClass='my-custom-class'>
            <IonHeader>
              <IonToolbar>
                <IonTitle>Filter</IonTitle>
                <IonButtons slot="end">
                  <IonButton onClick={() => setShowFilter(false)}>Zavřít</IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent>
              <IonList>
                <IonItem>
                  <IonLabel position="stacked">Identifikátor</IonLabel>
                  <IonInput
                    value={identifierDraft}
                    placeholder="Začněte psát…"
                    autocomplete="off"
                    onIonInput={(e) => {
                      const v = e.detail.value ?? "";
                      setIdentifierDraft(v);
                      scheduleIdSuggest(v);
                    }}
                  />
                </IonItem>
                {idSuggestions.length > 0 && (
                  <div style={{ maxHeight: 200, overflowY: "auto" }}>
                    {idSuggestions.map((s) => (
                      <IonItem key={s} button onClick={() => { setIdentifierDraft(s); setIdSuggestions([]); }}>
                        <IonLabel>{s}</IonLabel>
                      </IonItem>
                    ))}
                  </div>
                )}
                <IonItem>
                  <IonLabel position="stacked">Místo vzletu nebo přistání</IonLabel>
                  <IonInput
                    value={placeDraft}
                    placeholder="Začněte psát…"
                    autocomplete="off"
                    onIonInput={(e) => {
                      const v = e.detail.value ?? "";
                      setPlaceDraft(v);
                      schedulePlaceSuggest(v);
                    }}
                  />
                </IonItem>
                {placeSuggestions.length > 0 && (
                  <div style={{ maxHeight: 200, overflowY: "auto" }}>
                    {placeSuggestions.map((s) => (
                      <IonItem key={s} button onClick={() => { setPlaceDraft(s); setPlaceSuggestions([]); }}>
                        <IonLabel>{s}</IonLabel>
                      </IonItem>
                    ))}
                  </div>
                )}
                <IonItem>
                  Datum:
                  <Flatpickr value={filterDay} options={{dateFormat: "d.m.Y", locale: "cs", minDate: "1.7.2021" }}
                             onChange={onDateChange} />
                </IonItem>
              </IonList>
            </IonContent>
            <IonButton onClick={() => {applyFilter()}}>Filtrovat</IonButton>
          </IonModal>
          {/*<AprsLogbookList key={'aprsLogbookList'} ref={refContainer} loadApiQuery={'sort=day,desc&sort=takeOff,desc'}/>*/}
          <AprsLogbookContent
              key={'aprsLogbookList'}
              ref={refContainer}
              urlResource={getUrlApiQuery()}
              place={filterPlace}
              identifier={filterIdentifier}
              day={filterDay}
              setPlace={setFilterPlace}
              setIdentifier={setFilterIdentifier}
          />
          {/*showToast &&
          <IonToast
              isOpen={showToast}
              onDidDismiss={() => setShowToast(false)}
              message={toastMessage}
              duration={5000}
          />
          */}
        </IonContent>
      </IonPage>
  );
};

const mapStateToProps = state => {
  return {
    day:state? state.day: ""
  }
};


export const AprsLogbook = connect(
    mapStateToProps,
    null
)(AprsLogbookCls)